import React from 'react'
import { ComingSoon } from '../../../Components'

export default function Artical() {
    return (
        <div><ComingSoon /></div>
    )
}
